import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MasterService } from 'src/app/services/master.service';
import { MessageService } from 'src/app/services/message.service';
import * as words from '../../../../services/language'

@Component({
    selector: 'associations',
    templateUrl: './associations.component.html',
    styleUrls: ['./associations.component.scss'],
    standalone: false
})

export class AssociationsComponent implements OnInit, OnChanges {
    
    /** Unique internal identity of the contact whose associations (relatives, relations) will be displayed. */
    @Input() contactId: number = 0
    
    /** Library to maintain multi-lingual support. */
    protected words = words.language
    
    /** Current language of the user. */
    protected language: string = 'EN'

    /** A list of people or companies associated with the given contact. */
    protected associations: any = []

    constructor(private route: ActivatedRoute, private ms: MessageService, private master: MasterService, private router: Router) {}

    ngOnInit() {
        this.fetch()
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes) {
            return
        }

        const first = Object.values(changes).some(c => c.isFirstChange())
        if (first) {
            return
        }

        if (changes.contactId) {
            this.fetch()
        }
    }

    protected listenerNav = (e): void => {
        switch (e['message']) {
            case 'changeLanguage':
                this.language = e['value']
                break
        }
    }

    private fetch = (): void => {
        this.associations = []
        if (!this.contactId || (this.contactId <= 0)) {
            return
        }

        this.master.get(`contacts/${this.contactId}/relationships`, (res: { status: number; data: { error: any; relationships: []; }; }) => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }
            
            this.associations = res.data.relationships
        })
    }
}
